import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "src/store/rootReducer";
import { AdminSettings } from "../../types/strapiGOS";

export const gosSettingsSelector = createSelector(
  (state: RootState) => state.gosStrapi.settings,
  (state: AdminSettings) => state.data,
);

export const gosSettingsStatusSelector = createSelector(
  (state: RootState) => state.gosStrapi.settings,
  (state: AdminSettings) => state.fetchingStatusSettings,
);
